import { Table, TableBody, TableCell, TableHead } from '@mui/material'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ShowMoreOrLessButton from '../common/util/input/ShowMoreOrLessButton'
import { get } from '../helpers/Api'
import LoadingIndicator from '../loadingindicator/LoadingIndicator'
import CollectionRankingElement from './CollectionRankingElement'
import StatsElement from './StatsElement'

function TopCollections(props) {
    const [chartRange, setChartRange] = useState(1)
    const [revenueHistory, setRevenueHistory] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const { t } = useTranslation('common')
    const searchAuthor = props['searchAuthor']
    const [showNum, setShowNum] = useState(10)

    const [volumeType, setVolumeType] = useState('all')

    const selectVolumeType = (target) => {
        setVolumeType(target)
    }

    const GetRevenueHistory = async (range, author) => {
        setIsLoading(true)

        await get(
            `top-collections/${range}?limit=${showNum}&type=${volumeType}`,
            'v3',
        ).then(setRevenueHistory)
        setIsLoading(false)
    }

    useEffect(() => {
        GetRevenueHistory(chartRange, searchAuthor)
    }, [chartRange, searchAuthor, showNum, volumeType])

    const chartDropDownOptions = [
        { value: 1, label: t('analytics.24h_collection_volume') },
        { value: 2, label: t('analytics.days_collection_volume', { days: 2 }) },
        { value: 3, label: t('analytics.days_collection_volume', { days: 3 }) },
        { value: 7, label: t('analytics.days_collection_volume', { days: 7 }) },
        {
            value: 15,
            label: t('analytics.days_collection_volume', { days: 15 }),
        },
        {
            value: 30,
            label: t('analytics.days_collection_volume', { days: 30 }),
        },
        {
            value: 60,
            label: t('analytics.days_collection_volume', { days: 60 }),
        },
        {
            value: 90,
            label: t('analytics.days_collection_volume', { days: 90 }),
        },
        {
            value: 120,
            label: t('analytics.days_collection_volume', { days: 120 }),
        },
        {
            value: 180,
            label: t('analytics.days_collection_volume', { days: 180 }),
        },
        {
            value: 270,
            label: t('analytics.days_collection_volume', { days: 270 }),
        },
        {
            value: 365,
            label: t('analytics.days_collection_volume', { days: 365 }),
        },
    ]

    const onSelectChartRange = (e) => {
        if (e.target.value !== chartRange) setChartRange(e.target.value)
    }

    const textClass = cn('px-2 py-4')
    return (
        <StatsElement
            title={''}
            chartRange={chartRange}
            onChange={onSelectChartRange}
            chartDropDownOptions={chartDropDownOptions}
            volumeType={volumeType}
            selectVolumeType={selectVolumeType}
        >
            <div
                className={cn('w-full h-full overflow-x-auto')}
                id={'CollectionRankings'}
            >
                {isLoading ? (
                    <LoadingIndicator />
                ) : (
                    <div className="relative w-full mb-auto">
                        <Table size="small" sx={{ width: '100%' }}>
                            <TableHead>
                                <TableCell />
                                <TableCell />
                                <TableCell>{t('landing.name_col')}</TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-middle')}
                                >
                                    {t('landing.volume_wax_col')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-middle')}
                                >
                                    {t('landing.volume_usd_col')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-right')}
                                >
                                    {t('landing.change_col')}
                                </TableCell>
                                <TableCell
                                    className={cn(textClass, 'text-right')}
                                >
                                    {t('landing.sales_col')}
                                </TableCell>
                            </TableHead>
                            <TableBody className="overflow-y-auto">
                                {revenueHistory &&
                                    revenueHistory.map((volume, index) => (
                                        <CollectionRankingElement
                                            key={
                                                'CollectionRankingElement-' +
                                                index
                                            }
                                            volume={volume}
                                            index={index}
                                            target={'stats?collection='}
                                        />
                                    ))}
                            </TableBody>
                        </Table>
                    </div>
                )}
                <div className={'flex justify-center'}>
                    {!isLoading && revenueHistory ? (
                        <ShowMoreOrLessButton
                            showNum={showNum}
                            setShowNum={setShowNum}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </StatsElement>
    )
}

export default TopCollections
